import { IHttpApi, IModel, IModelResponse } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

const defaultConfig: TGetYandexWidgetTokenModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'POST',
  microserviceName: 'billingAccounts',
  pathApi: '/v1/deposit-amount-widget/',
};

export type TGetYandexWidgetTokenModel = IModel<IGetYandexWidgetTokenRequest, IGetYandexWidgetTokenResponse>;

export interface IGetYandexWidgetTokenRequest {
  /** Сумма пополнения */
  amount: number;
}

export interface IGetYandexWidgetTokenResponseSchema {
  /** Токен для виджета Яндекс.Кассы */
  confirmationToken: string;
}

export interface IGetYandexWidgetTokenResponse extends IModelResponse<IGetYandexWidgetTokenResponseSchema> {
  statusCode: 200;
}

export function createModel(config: Partial<TGetYandexWidgetTokenModel>): TGetYandexWidgetTokenModel {
  return {
    ...defaultConfig,
    ...config,
  };
}

export interface IGetYandexWidgetTokenDependencies {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const getYandexWidgetToken = async (
  dependencies: IGetYandexWidgetTokenDependencies,
  parameters: IGetYandexWidgetTokenRequest,
) => {
  const { httpApi, logger } = dependencies;

  const requestConfig = {
    withCredentials: true,
    headers: [[ 'Content-Type', 'application/json' ]] as [string, string][],
  };

  try {
    const { response } = await httpApi.fetch(createModel({ parameters }), { requestConfig });

    return response;
  } catch (error) {
    logger.error(
      error,
      {
        description: 'Billing-accounts v1/deposit-amount-widget rejection error',
        degradation: 'Пользователь хотел оплатить, но мы не смогли этого сделать',
        requestParameters: { ...parameters },
      },
    );

    return Promise.resolve({});
  }
};
